import { Directive, HostListener } from "@angular/core";

@Directive()
export abstract class ComponentCanDeactivate {

    abstract canDeactivate(): boolean;

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}
